<template>
    <div class="about">
      <h1>Bienvendio al Login</h1>
    </div>
  </template>

<style scoped>
.about {
  margin-top: 2.2rem;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 15rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgb(27,99,149);
}
h1 {
  font-size: 2rem;
  color: #eeeeee;
}
</style>